module.exports = __webpack_public_path__ + "img/134.3293641a.jpg";